export default __webpack_public_path__ + "static/media/home-image-one.2b568200.jpeg";